export default { sha: '9c12c9fa6a67623539ba08d93931e08bf9869e92', buildNumber: 'undefined' }
